module.exports = __webpack_public_path__ + "img/assess-logos.59a55f5.png";